import { Row, Col } from "antd";
import { useEffect, useState } from "react";
import { machineCardTheme } from "../../Colors/colors";
import { MachinesByGroup } from "../../Types/dashboardTypes";
import { HistoricalTsiDataType } from "../../Types/portalTypes";
import MyScatterChart from "../Charts/MyScatterChart";
import Dropdown from "../Dropdown/Dropdown";

import "./OEEGraphCard.less";

interface Props {
  machinesByGroup: MachinesByGroup[];
  groupHistoricalData: HistoricalTsiDataType;
}
interface MachinesByGroupColors {
  [key: string]: string;
}
const OEEGraphCard: React.FC<Props> = (props) => {
  const { machinesByGroup, groupHistoricalData } = props;
  const [selectedMachines, setSelectedMachines] = useState<MachinesByGroup[]>([]);
  const [selectedData, setSelectedData] = useState<HistoricalTsiDataType>({});
  const [machinesByGroupColors, setMachinesByGroupColors] = useState<MachinesByGroupColors>({});
  const [colors, setColors] = useState<string[]>([]);

  useEffect(() => {
    const defaultSelection = machinesByGroup.slice(0, 3);
    setSelectedMachines(defaultSelection);

    const data: HistoricalTsiDataType = {};
    defaultSelection.forEach((e) => {
      data[e.machineSerial] = groupHistoricalData[e.machineSerial];
    });
    setSelectedData(data);

    const colors: MachinesByGroupColors = {};
    for (let i = 0; i < machinesByGroup.length; i++) {
      colors[machinesByGroup[i].machineSerial] = machineCardTheme[i][1];
    }
    setMachinesByGroupColors(colors);
  }, [machinesByGroup, groupHistoricalData]);

  const onSelectChange = (value: string[]) => {
    const selection = machinesByGroup.filter((e) => value.includes(e.machineSerial));
    setSelectedMachines(selection);
  };

  useEffect(() => {
    const data: HistoricalTsiDataType = {};
    const colors: string[] = [];
    selectedMachines?.forEach((e) => {
      data[e.machineSerial] = groupHistoricalData[e.machineSerial];
      colors.push(machinesByGroupColors[e.machineSerial]);
    });
    setSelectedData(data);
    setColors(colors);
  }, [selectedMachines]);

  return (
    <div className="oee-graph-card">
      <Row className="oee-graph-header">
        <Col className="group-card-title">OEE Comparison</Col>
        <Col span={9}>
          <Dropdown
            title="Comparing"
            options={machinesByGroup.map((e) => ({ label: e.machineName, value: e.machineSerial }))}
            value={selectedMachines.map((e) => e.machineSerial) ?? []}
            multiSelect={"multiple"}
            menuItemSelectedIcon={<></>}
            onChange={(value) => onSelectChange(value as string[])}
            maxTagCount={1}
            mainClassName={"multi-select-option"}
          />
        </Col>
      </Row>
      <Row className="line-chart-wrapper">
        <MyScatterChart colors={colors} machines={selectedMachines} selectedData={selectedData} />
      </Row>
    </div>
  );
};

export default OEEGraphCard;
